// Copyright (c) 2016 Deere & Company

import './radio-button-list.scss';
import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RadioButtonRow from './radio-button-row';

function handleItemUpdate(index) {

    this.onItemsUpdate(index);

}

const isSelected = (selectedKey, itemKey) => selectedKey === itemKey;

const selectedClassName = selected => selected ? 'selected' : '';

const RadioButtonList = props =>
    <ul className='key-value-radio-list'>
        {
            props.items.map((item, index) => (
                <RadioButtonRow
                    className={selectedClassName(isSelected(props.selectedKey, item.key))}
                    isSelected={isSelected(props.selectedKey, item.key)}
                    item={item}
                    key={index}
                    onItemUpdate={handleItemUpdate.bind(props, index)}
                />
            ))
        }
    </ul>;

RadioButtonList.displayName = 'RadioButtonList';
RadioButtonList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onItemsUpdate: PropTypes.func.isRequired,
    selectedKey: PropTypes.string.isRequired
};

export default RadioButtonList;



// WEBPACK FOOTER //
// ./src/shared/components/radio-button-list/radio-button-list.js